<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p5"><span><a href="#/Contents#rp5">TURKEY STOCK</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="normal"><span><i>The perfect ending for the Thanksgiving turkey, this stock can be used for Turkey-Noodle Soup (see <span href="#/Chapter0576#p262" title="Link target outside of Sample">p. 202</span>) or as a substitute in recipes calling for chicken stock.</i></span></p>
<p class="make"><span>Makes about 4 quarts</span></p>
<p class="hang"><span>5 quarts water</span></p>
<p class="hang"><span>1 cup dry white wine or water</span></p>
<p class="hang"><span>1 meaty turkey carcass, cut up</span></p>
<p class="hang"><span>2 each: thickly sliced medium onions, leeks (white parts only)</span></p>
<p class="hang"><span><a id="page_5"></a>4 each: thickly sliced medium carrots, ribs celery</span></p>
<p class="hang"><span>1 teaspoon dried thyme leaves</span></p>
<p class="hang"><span>10 black peppercorns</span></p>
<p class="hang"><span>6 sprigs parsley</span></p>
<p class="hang"><span>Salt and pepper, to taste</span></p>
<p class="normalt"><span><b>1.</b> Heat all ingredients, except salt and pepper, in large Dutch oven to boiling; reduce heat and simmer, covered, 3 to 4 hours, skimming any foam from surface. Strain stock through double layer of cheesecloth, discarding bones, vegetables, and seasonings; season to taste with salt and pepper. Refrigerate until chilled; remove congealed fat from surface of stock.</span></p>
<p class="per"><span>Per Cup:</span></p>
<p class="per1"><span>Calories: 29</span></p>
<p class="per1"><span>% calories from fat: 28</span></p>
<p class="per1"><span>Protein (g): 2</span></p>
<p class="per1"><span>Carbohydrate (g): 0.9</span></p>
<p class="per1"><span>Fat (g): 0.9</span></p>
<p class="per1"><span>Saturated fat (g): 0.2</span></p>
<p class="per1"><span>Cholesterol (mg): 5.6</span></p>
<p class="per1"><span>Sodium (mg): 7</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.0</span></p>
<p class="per1"><span>Vegetable: 0.0</span></p>
<p class="per1"><span>Fruit: 0.0</span></p>
<p class="per1"><span>Bread: 0.0</span></p>
<p class="per1"><span>Meat: 0.0</span></p>
<p class="per1"><span>Fat: 0.0</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter015.vue?113e927f